/**
 * Filtres persistés de la page /notifications (WKF-013 §7.2, retour PO).
 *
 * Deux bascules composables « En retard » + « Urgentes », persistées dans
 * `user_preferences.data.notification_filters` (serveur, multi-appareils) — même
 * mécanisme que `useTaskViewPreferences`. On envoie l'objet COMPLET à chaque
 * écriture (le backend remplace la clé en bloc, pas de deep-merge).
 */

import { useCallback } from 'react'

import { useAuth } from '@/contexts/AuthContext'

export function useNotificationFilterPreferences() {
    const { user, updatePreferences } = useAuth()
    const saved = user?.preferences?.notification_filters

    const overdue = saved?.overdue ?? false
    const urgent = saved?.urgent ?? false

    const setOverdue = useCallback(
        (v: boolean) => {
            void updatePreferences({ notification_filters: { ...saved, overdue: v } })
        },
        [updatePreferences, saved],
    )
    const setUrgent = useCallback(
        (v: boolean) => {
            void updatePreferences({ notification_filters: { ...saved, urgent: v } })
        },
        [updatePreferences, saved],
    )

    return { overdue, urgent, setOverdue, setUrgent }
}
